export const pinFileToIPFSurl = `https://api.pinata.cloud/pinning/pinFileToIPFS`;
export const pinListUrl = `https://api.pinata.cloud/data/pinList?status=pinned&pageLimit=100`;
//export const pinListUrl = `https://api.pinata.cloud/data/pinList?pageLimit=100`;
export const pinUpdateMetaUrl = 'https://api.pinata.cloud/pinning/hashMetadata';
export const coingeckoUrl = `https://api.coingecko.com/api/v3/simple/price?ids=DAI&vs_currencies=EUR`;
export const pinJSONToIPFSurl = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;

/*
export const pinFileToIPFSurl = `https://ato-nft.mypinata.cloud/ipfs/pinning/pinFileToIPFS`;
export const pinListUrl = `https://ato-nft.mypinata.cloud/ipfs/pinList?status=pinned&pageLimit=100`;
export const pinUpdateMetaUrl = 'https://ato-nft.mypinata.cloud/ipfs/pinning/hashMetadata';
export const pinJSONToIPFSurl = `https://ato-nft.mypinata.cloud/ipfs/pinning/pinJSONToIPFS`;

export const coingeckoUrl = `https://api.coingecko.com/api/v3/simple/price?ids=DAI&vs_currencies=EUR`;
*/